import React, { useLayoutEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCMS } from "../fetch/cms/main";
import { Puff } from "../Components/Layout/Loading";
import { fetchInput } from "../fetch/input/main";
import { fetchFreelancers } from "../fetch/freelancer/all";
import { fetchVacancies } from "../fetch/vacancy/all";

function AdBox({ banner }) {
  console.log("AdBox - banner:", banner);
  
  const redirectToExternalWebsite = () => {
    if (banner?.link) {
      window.location.href = banner.link;
    }
  };
  
  if (!banner?.img) {
    console.log("AdBox - No banner image, returning null");
    return null;
  }
  
  return (
    <>
      <section className="section-add">
        <div className="container" onClick={redirectToExternalWebsite}>
          <img
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "10px",
              cursor: banner?.link ? "pointer" : "default",
            }}
            src={banner.img}
            alt="Advertisement"
          />
        </div>
      </section>
    </>
  );
}

const HowItWorksBox = ({ data }) => {
  console.log("HowItWorksBox - data:", data);
  const vidRef = useRef(null);
  const ref = useRef(null);

  if (!data) {
    console.log("HowItWorksBox - No data, returning null");
    return null;
  }

  return (
    <div
      className="col-lg-6 box"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        <h3 className="">{data?.title || ''}</h3>
        <div
          style={{ fontSize: "1.7rem" }}
          dangerouslySetInnerHTML={{
            __html: data?.content || '',
          }}
        />
      </div>
      <div
        ref={ref}
        style={{
          cursor: "pointer",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          marginTop: "2rem",
          width: "auto",
          height: "auto",
          paddingTop: "56.25%",
        }}
      >
        {data?.img && (
          <video
            className="video3"
            controls
            height="100%"
            width="100%"
            style={{ position: "absolute", top: 0, left: 0, height: "100%" }}
            ref={vidRef}
          >
            <source src={data.img} />
          </video>
        )}
      </div>
    </div>
  );
};

const Index = () => {
  console.log("=== Index Component Mounting ===");
  const { isLoading, error, data } = fetchCMS();
  const navigate = useNavigate();

  console.log("Index - isLoading:", isLoading);
  console.log("Index - error:", error);
  console.log("Index - data:", data);
  console.log("Index - data?.works:", data?.works);

  // Handle error state
  if (error) {
    console.error("❌ CMS fetch error:", error);
    return <div style={{ padding: '20px', color: 'red' }}>Error loading content: {error?.message || 'Unknown error'}</div>;
  }
  
  // Wait for data to load completely - check all required fields
  if (isLoading || !data || !data.works) {
    console.log("⏳ Index - Still loading or no data. isLoading:", isLoading, "data:", !!data, "data.works:", !!data?.works);
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "50rem",
          alignItems: "center",
        }}
      >
        <Puff />
      </div>
    );
  }

  console.log("✅ Index - Data loaded successfully");
  const dataWorks = data.works;

  return (
    <>
      <MainBox data={data} />
      <AdBox banner={dataWorks?.banners} />
      
      <section className="section2" style={{ marginBottom: "10rem" }}>
        <div className="container">
          <h1 className="heading">How it works</h1>
          <div className="row">
            <HowItWorksBox data={dataWorks?.forBusiness} key="forbusivid" />
            <HowItWorksBox data={dataWorks?.forFreelancer} key="forfreevid" />
          </div>
        </div>
      </section>

      <section className="section3">
        <div className="container">
          <div className="cover-img">
            <h1
              className="heading"
              dangerouslySetInnerHTML={{
                __html: dataWorks?.freelancerContent?.title || '',
              }}
            />
            <p
              className="title"
              style={{ fontSize: "2rem" }}
              dangerouslySetInnerHTML={{
                __html: dataWorks?.freelancerContent?.content || '',
              }}
            />
            <div className="cards" style={{ color: "white" }}>
              {(dataWorks?.freelancerContent?.subContent || []).map((val, idx) => (
                <ImgCaptionBox
                  key={idx}
                  img={val?.img}
                  header={val?.title}
                  para={val?.content}
                  bigImg
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section4">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-md-8 col-sm-12">
              <h1
                className="heading"
                dangerouslySetInnerHTML={{
                  __html: dataWorks?.eConsultant?.title || '',
                }}
              />
              <p
                className="title"
                style={{ fontSize: "2rem" }}
                dangerouslySetInnerHTML={{
                  __html: dataWorks?.eConsultant?.content || '',
                }}
              />
            </div>
            <div className="col-lg-3 col-md-4 col-sm-12 align-self-center text-center">
              <img src="images/h-icon4.png" alt="" />
            </div>
          </div>
        </div>
      </section>

      <section className="section5" style={{ marginBottom: "4rem" }}>
        <div className="container">
          <div className="cards">
            {(dataWorks?.eConsultant?.subContent || []).map((val, idx) => (
              <ImgCaptionBox
                key={idx}
                img={val?.img}
                header={val?.title}
                para={val?.content}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

function MainBox({ data }) {
  console.log("=== MainBox Component ===");
  console.log("MainBox - data received:", data);
  console.log("MainBox - data?.title:", data?.title);
  console.log("MainBox - data?.titleContent:", data?.titleContent);
  
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("Auth");

  // Pre-fetching
  fetchInput();
  fetchFreelancers({ page: 0 });
  fetchVacancies(1, {});

  function iAmLink() {
    isLoggedIn ? navigate("/vacancies") : navigate("/signup");
  }
  
  function iNeedLink() {
    isLoggedIn ? navigate("/vacancies/create") : navigate("/signup");
  }

  // Extra safety check - this should never happen if Index component checks properly
  if (!data) {
    console.error("❌ MainBox - No data received! This should not happen.");
    return null;
  }

  // Extract values safely
  const pageTitle = data?.title || "Welcome";
  const pageContent = data?.titleContent || "";
  
  console.log("✅ MainBox - Rendering with title:", pageTitle);

  return (
    <>
      <section className="section2" style={{ marginBlock: "8rem" }}>
        <div
          className="container"
          style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
        >
          <h1 className="heading">{pageTitle}</h1>
          {pageContent && (
            <p
              className="title"
              style={{ fontSize: "2rem" }}
              dangerouslySetInnerHTML={{
                __html: pageContent,
              }}
            />
          )}

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "3rem",
            }}
          >
            <a className="LinkButtonReact" onClick={iNeedLink}>
              I NEED A FREELANCER
            </a>
            <a className="LinkButtonReact" onClick={iAmLink}>
              I AM A FREELANCER
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

function ImgCaptionBox({ img, header, para, bigImg }) {
  const elRef = useRef();
  const navigate = useNavigate();
  const link = header?.toLowerCase()?.includes("booking")
    ? "/freelancers"
    : false;

  // For styling data fetched from backend
  useLayoutEffect(() => {
    if (elRef.current) {
      const firstPara = elRef.current.querySelectorAll("p")[0];
      if (firstPara) firstPara.style.fontSize = "1.5rem";
    }
  }, []);

  if (!img || !header) {
    console.log("ImgCaptionBox - Missing img or header, returning null");
    return null;
  }

  return (
    <div
      className="box"
      style={{
        display: "flex",
        flexDirection: "column",
        cursor: link ? "pointer" : "default",
      }}
      onClick={() => {
        if (link) navigate(link);
      }}
    >
      <div
        style={{
          height: bigImg ? "15rem" : "10rem",
        }}
      >
        <img 
          style={{ height: bigImg ? "13rem" : "6rem" }} 
          src={img} 
          alt={header} 
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h6 style={{ fontSize: "1.9rem" }}>{header}</h6>
        <div
          className="htmlinnerpara"
          ref={elRef}
          style={{ fontSize: "1.5rem" }}
          dangerouslySetInnerHTML={{
            __html: para || '',
          }}
        />
      </div>
    </div>
  );
}

export default Index;
